var map = {
	"./DownArrow.svg": "+0Tf",
	"./Facebook.svg": "0RnZ",
	"./HomeHeroOverlay.svg": "HdJE",
	"./Instagram.svg": "4laX",
	"./KidsClub.svg": "+qMA",
	"./LeftArrow.svg": "Ruwq",
	"./Location.svg": "hOR3",
	"./LogoColor.svg": "GQul",
	"./LogoWhite.svg": "/DxR",
	"./Phone.svg": "/VDe",
	"./RightArrow.svg": "yT3g",
	"./TestimonialOverlay.svg": "F4O7",
	"./TestimonialOverlay1.svg": "P/CC",
	"./map-pin.svg": "hN6K"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 1